import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {getCookie } from "../../utils/cookie";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API_V2;

export interface ResetResult {
    data: any[];
}

export const createSupplier = createAsyncThunk(
    'supplier/create',
    async (post_data: any, { rejectWithValue }) => {
        const { id}  = getCookie('auth')
        const createURL = `${URL_API}/admin-portal/suppliers`;

        try {
            const { data } = await axios.post<ResetResult>(createURL, post_data, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);